export const REACT_FULLPAGE_KEY = "1B0C42AA-0AB84DFA-B6B2901B-3F9CF551";
export const REACT_FULLPAGE_RESPONSIVE_WIDTH = 1024;
export const API_SERVER = process.env.REACT_APP_API;
export const ACCESS_TOKEN = "_ac_tk";
